<ng-container *ngIf="moduleManager.settingsView === 'cxOneModal'">
    <div cvModuleCxoneCustomSettingSection after="dates" class="agentStateSummarySettings gridItemSettingsPanelCustomSettingsBottomItem my-4" [moduleManager]="moduleManager">
        <div class="form-group custom-setting-section-availability-checkbox pb-0 d-flex justify-content-start w-100">
            <cxone-checkbox type="checkbox" [labelText]="getLocalizationString('Show_Unavailable_States', 'Show Only Unavailable States')" class="unavailable-checkbox" [(ngModel)]="onlyUnavailable"></cxone-checkbox>
        </div>
    </div>
</ng-container>